// store.ts
import { configureStore } from '@reduxjs/toolkit';
import consentReducer from './slices/consentSlice';
import customerReducer from './slices/customerSlice';
import documentReducer from './slices/documentSlice';
import modalReducer from './slices/modalSlice';
import partyReducer from './slices/partySlice';
import policiesReducer from './slices/policiesSlice';
import policyObjectsExportReducer from './slices/policyObjectsExportSlice';
import policyOverviewDocumentReducer from './slices/policyOverviewDocumentSlice';
import policyReducer from './slices/policySlice';

export const store = configureStore({
	reducer: {
		consents: consentReducer,
		customer: customerReducer,
		policies: policiesReducer,
		party: partyReducer,
		documents: documentReducer,
		policyDetails: policyReducer,
		modal: modalReducer,
		policyObjectsExport: policyObjectsExportReducer,
		policyOverviewDocument: policyOverviewDocumentReducer,
	},
});

// Export store types for use in components
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
